import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = (fromMd?: boolean) =>
  ({
    header: {
      position: "sticky",
      top: "0",
      zIndex: 1,
      background: colors.white
    },
    headerContent: {
      padding: "10px 24px 9px 24px",
      borderBottom: `1px solid ${colors.gray200}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    navbarItemsBlock: {
      display: "flex",
      alignItems: "center"
    },
    menuButton: {
      marginLeft: "8px"
    },
    navbarControls: {
      display: "flex",
      alignItems: "center",
      marginLeft: "4px",
      "@media (max-width: 839px)": {
        marginLeft: "0",
        display: "block"
      },

      "button + button": {
        marginLeft: "4px",
        "@media (max-width: 839px)": {
          marginLeft: "0"
        }
      }
    },
    settingsDesktopMenu: {
      "& .MuiMenu-paper": {
        width: "315px"
      }
    },
    notificationsButton: {
      "&:hover": {
        background: colors.gray200,
        "@media (max-width: 839px)": {
          background: colors.gray100
        }
      },

      "&:active": {
        background: colors.gray300,
        "@media (max-width: 839px)": {
          background: colors.gray200
        }
      }
    },
    notificationsDesktopMenu: {
      "& .MuiMenu-paper": {
        width: "564px"
      }
    },
    settingsContentTop: {
      display: "flex",
      alignItems: "center",
      padding: "12px 16px"
    },
    settingsContentTopData: {
      display: "flex",
      flexDirection: "column",
      color: colors.textDark,

      letterSpacing: "0.4px",
      wordBreak: "break-all"
    },
    navbarButtonTitle: {
      maxWidth: "142px",
      textOverflow: "ellipsis",
      overflowX: "hidden",
      fontWeight: 600 // this is the defsult button font weight and it should not be changed when changin main font
    },
    searchCompanyDiv: {
      padding: "12px 16px"
    },
    rootCompanyDiv: {
      padding: "12px 16px 4px 16px"
    },
    companySelectorTopLogo: {
      display: "flex",
      justifyContent: "space-between",
      padding: "16px 0 4px 24px"
    },
    navbarItemTopControls: {
      position: "relative",
      display: "flex",
      justifyContent: "space-between",

      "& > button": {
        position: "absolute",
        top: "4px",
        right: "4px"
      }
    },
    navbarItemDialogTitle: {
      color: colors.textDark,
      alignSelf: "flex-end"
    },
    childCompaniesCount: {
      color: colors.textPlaceholder,
      padding: "12px 16px 4px 16px"
    },
    selectCompanyRadioGroupCSS: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
      marginBottom: "14px",
      maxHeight: fromMd ? "445px" : "unset",
      overflow: "auto",

      "& > label + label": {
        marginTop: "6px"
      }
    },
    noCompaniesFoundCSS: {
      lineHeight: "24px",
      color: colors.textPlaceholder,
      padding: "12px 16px",
      fontWeight: 400
    },
    notFountToolDiv: {
      marginTop: "16px",
      width: "100%",
      textAlign: "center"
    }
  }) as CSSObject;
